import {
    bodyComposition, bodyShapeAnswer, Gender, shouldersWiderThanHipsAnswer,
    weightPatternAnswer, wristEncircleAnswer,
} from 'fitbeat.models';

export const WeightPatternMap = new Map<weightPatternAnswer, { [key: string]: number }>();
WeightPatternMap.set(weightPatternAnswer.troubleGainingWeight, {
    [bodyComposition.ecto]: 1,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 0.5,
    [bodyComposition.endo_meso]: 0,
    [bodyComposition.meso]: 0,
});
WeightPatternMap.set(weightPatternAnswer.gainAndLoseWeightEasy, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 0.5,
    [bodyComposition.ecto_meso]: 0.5,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 1,
});
WeightPatternMap.set(weightPatternAnswer.gainWeightEasyLosingHard, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 1,
    [bodyComposition.ecto_meso]: 0,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 0,
});

export const ShouldersWiderThanHipsMap = new Map<shouldersWiderThanHipsAnswer, { [key: string]: number }>();
ShouldersWiderThanHipsMap.set(shouldersWiderThanHipsAnswer.yes, {
    [bodyComposition.ecto]: 0.5,
    [bodyComposition.endo]: 0.5,
    [bodyComposition.ecto_meso]: 0.5,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 1,
});
ShouldersWiderThanHipsMap.set(shouldersWiderThanHipsAnswer.noHipsWider, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 1,
    [bodyComposition.ecto_meso]: 0,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 0,
});
ShouldersWiderThanHipsMap.set(shouldersWiderThanHipsAnswer.noHipsSame, {
    [bodyComposition.ecto]: 1,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 1,
    [bodyComposition.endo_meso]: 0,
    [bodyComposition.meso]: 0,
});

export const BodyShapeMap = new Map<bodyShapeAnswer, { [key: string]: number }>();
BodyShapeMap.set(bodyShapeAnswer.pencil, {
    [bodyComposition.ecto]: 1,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 0.5,
    [bodyComposition.endo_meso]: 0,
    [bodyComposition.meso]: 0,
});
BodyShapeMap.set(bodyShapeAnswer.hourGlass, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 1,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 1,
});
BodyShapeMap.set(bodyShapeAnswer.appleOrPear, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 1,
    [bodyComposition.ecto_meso]: 0,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 0,
});

export const WristEncircleMap = new Map<wristEncircleAnswer, { [key: string]: number }>();
WristEncircleMap.set(wristEncircleAnswer.notTouch, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 0.5,
    [bodyComposition.ecto_meso]: 0,
    [bodyComposition.endo_meso]: 1,
    [bodyComposition.meso]: 0.5,
});
WristEncircleMap.set(wristEncircleAnswer.justTouch, {
    [bodyComposition.ecto]: 0,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 0.5,
    [bodyComposition.endo_meso]: 0.5,
    [bodyComposition.meso]: 1,
});
WristEncircleMap.set(wristEncircleAnswer.overlap, {
    [bodyComposition.ecto]: 1,
    [bodyComposition.endo]: 0,
    [bodyComposition.ecto_meso]: 1,
    [bodyComposition.endo_meso]: 0,
    [bodyComposition.meso]: 0,
});

export const bodyFatAdjustPercentages = {
    [bodyComposition.ecto]: { firstSubtraction: 0, min: 6 },
    [bodyComposition.ecto_meso]: { firstSubtraction: 2, min: 6 },
    [bodyComposition.meso]: { firstSubtraction: 6, min: 6 },
    [bodyComposition.endo_meso]: { firstSubtraction: 2, min: 6 },
    [bodyComposition.endo]: { firstSubtraction: 0, min: 6 },
};

export const athleteAdjustmentRange: {
    minBodyFat?: number;
    maxBodyFat?: number;
    bodyType: bodyComposition;
    gender: Gender;
    adjustment: number;
  }[] = [
    // ecto
    {minBodyFat: 10, bodyType: bodyComposition.ecto, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 10, maxBodyFat: 15, bodyType: bodyComposition.ecto, gender: Gender.Male, adjustment: 1},
    {maxBodyFat: 15, bodyType: bodyComposition.ecto, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 14, bodyType: bodyComposition.ecto, gender: Gender.Female, adjustment: 1},
    {minBodyFat: 14, maxBodyFat: 18, bodyType: bodyComposition.ecto, gender: Gender.Female, adjustment: 1},
    {maxBodyFat: 18, bodyType: bodyComposition.ecto, gender: Gender.Female, adjustment: 1},

    // ecto_meso
    {minBodyFat: 10, bodyType: bodyComposition.ecto_meso, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 10, maxBodyFat: 15, bodyType: bodyComposition.ecto_meso, gender: Gender.Male, adjustment: 2},
    {maxBodyFat: 15, bodyType: bodyComposition.ecto_meso, gender: Gender.Male, adjustment: 4},
    {minBodyFat: 14, bodyType: bodyComposition.ecto_meso, gender: Gender.Female, adjustment: 1},
    {minBodyFat: 14, maxBodyFat: 18, bodyType: bodyComposition.ecto_meso, gender: Gender.Female, adjustment: 1.5},
    {maxBodyFat: 18, bodyType: bodyComposition.ecto_meso, gender: Gender.Female, adjustment: 3},

    // meso
    {minBodyFat: 10, bodyType: bodyComposition.meso, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 10, maxBodyFat: 15, bodyType: bodyComposition.meso, gender: Gender.Male, adjustment: 3},
    {maxBodyFat: 15, bodyType: bodyComposition.meso, gender: Gender.Male, adjustment: 6},
    {minBodyFat: 14, bodyType: bodyComposition.meso, gender: Gender.Female, adjustment: 1},
    {minBodyFat: 14, maxBodyFat: 18, bodyType: bodyComposition.meso, gender: Gender.Female, adjustment: 2},
    {maxBodyFat: 18, bodyType: bodyComposition.meso, gender: Gender.Female, adjustment: 4},

    // endo_meso
    {minBodyFat: 10, bodyType: bodyComposition.endo_meso, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 10, maxBodyFat: 15, bodyType: bodyComposition.endo_meso, gender: Gender.Male, adjustment: 1},
    {maxBodyFat: 15, bodyType: bodyComposition.endo_meso, gender: Gender.Male, adjustment: 2},
    {minBodyFat: 14, bodyType: bodyComposition.endo_meso, gender: Gender.Female, adjustment: 1},
    {minBodyFat: 14, maxBodyFat: 18, bodyType: bodyComposition.endo_meso, gender: Gender.Female, adjustment: 1},
    {maxBodyFat: 18, bodyType: bodyComposition.endo_meso, gender: Gender.Female, adjustment: 2},

    // endo
    {minBodyFat: 10, bodyType: bodyComposition.endo, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 10, maxBodyFat: 15, bodyType: bodyComposition.endo, gender: Gender.Male, adjustment: 1},
    {maxBodyFat: 15, bodyType: bodyComposition.endo, gender: Gender.Male, adjustment: 1},
    {minBodyFat: 14, bodyType: bodyComposition.endo, gender: Gender.Female, adjustment: 1},
    {minBodyFat: 14, maxBodyFat: 18, bodyType: bodyComposition.endo, gender: Gender.Female, adjustment: 1},
    {maxBodyFat: 18, bodyType: bodyComposition.endo, gender: Gender.Female, adjustment: 1},
  ];

export const bodyFatProposedTrendline = {
    male: { x: 1.6229, y: 20.569 },
    maleMeso: { x: 1.6728, y: 24.588 },
    female: { x: 1.3482, y: 1.6884 },
};

export const safetyNetMaxUpperBorder = 4;
export const safetyNetMaxLowerBorder = 4;
